export default "__VITE_PUBLIC_ASSET__da5a0829__"